import EmitenteService from "@/services/EmitenteService";

export const emitente = {
  namespaced: true,
  state: {
    emitente: {},
  },
  actions: {
    getEmitente({ commit }, payload) {
      return EmitenteService.GetEmitente(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postEmitente({ commit }, payload) {
      return EmitenteService.PostEmitente(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putEmitente({ commit }, payload) {
      return EmitenteService.PutEmitente(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getLojaVirtual({ commit }, payload) {
      return EmitenteService.GetLojaVirtual(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getEmpresasLojaVirtual({ commit }, payload) {
      const query = new URLSearchParams(payload.replace(/^\?/, ""));
      const filtro = query.get("$filter") || "";
      const pesquisa = filtro.match(/contains\(nome, '((?:''|[^'])*)'\)/);
      return EmitenteService.GetEmpresasLojaVirtual({
        skip: Number(query.get("$skip") || 0),
        top: Number(query.get("$top") || 10),
        orderBy: query.get("$orderby") || "nome asc",
        search: pesquisa ? pesquisa[1].replaceAll("''", "'") : "",
      }).then(
        (response) =>
          Promise.resolve({
            value: response.Data.items,
            "@odata.count": response.Data.total,
          }),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    putLojaVirtual({ commit }, payload) {
      return EmitenteService.PutLojaVirtual(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    deleteEmitente({ commit }, payload) {
      return EmitenteService.DeleteEmitente(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getEmitenteOData({ commit }, payload) {
      return EmitenteService.GetEmitenteOData(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    postRegisterEmitente({ commit }, payload) {
      return EmitenteService.PostRegisterEmitente(payload).then(
        (emitente) => {
          return Promise.resolve(emitente);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default emitente;
